import { apiClient } from './client'

export type Testimonial = {
  id: string
  title: string
  description: string
  createdAt: string
  updatedAt?: string | null
}

export type TestimonialPayload = {
  title: string
  description: string
}

export async function getTestimonials() {
  const { data } = await apiClient.get<Testimonial[]>('/api/testimonials')
  return data
}

export async function createTestimonial(payload: TestimonialPayload) {
  const { data } = await apiClient.post<Testimonial>('/api/admin/testimonials', payload)
  return data
}

export async function updateTestimonial(id: string, payload: TestimonialPayload) {
  const { data } = await apiClient.put<Testimonial>(`/api/admin/testimonials/${id}`, payload)
  return data
}

export async function deleteTestimonial(id: string) {
  await apiClient.delete(`/api/admin/testimonials/${id}`)
}
